import { FontWeightEnum, TextVariantColorEnum } from '@app/common';
import { commonTextVariantClass, fontWeightClass } from '../../../../utils/tailwind';

export const getValueClassName = (
    color: TextVariantColorEnum,
    fontWeight: FontWeightEnum,
    display = 'inline-block',
) => {
    let displayClass = 'inline-block';

    if (display === 'block') {
        displayClass = 'block';
    } else if (display === 'inline-flex') {
        displayClass = 'inline-flex';
    }

    return [displayClass, 'whitespace-nowrap', commonTextVariantClass[color], fontWeightClass[fontWeight]].join(' ');
};

export const getLockedProps = (locked: boolean, blur: number) => {
    if (!locked) {
        return {};
    }

    return {
        className: 'select-none',
        style: {
            filter: `blur(${blur}rem)`,
        },
    };
};

export const nonVisibleValueClassName = 'text-inherit text-inherit [&_i]:h-[1.6rem] [&_i]:w-[1.6rem]';
